import React, { useCallback, useEffect, useRef, useState } from 'react'
import MasterHeader from '../../component/reusable/MasterHeader'
import api from '../../utils/api';
import { toast } from 'react-toastify';
import { Copy, Delete } from '../../Svg';
import { handleCopy } from '../../utils/fomateDate';
import CatPagination from '../../component/reusable/catPagination/CatPagination';
import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import DeleteModal from '../../component/reusable/deleteModal/DeleteModal';

const ActionButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    fontSize: '12px',
    color: '#512DA8',
    backgroundColor: '#F0F1F3',
    fontWeight: '600 !important',
    fontFamily: `'Public Sans', sans-serif`,
    padding: '4px 12px',
    borderRadius: '4px',
    '&:hover': {
        backgroundColor: '#e0e0e0',
    },
    '&.Mui-disabled': {
        opacity: 0.5,
        color: '#512DA8',
    }
}));

const DeleteButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    fontSize: '12px',
    color: '#fff',
    backgroundColor: '#512DA8',
    fontWeight: '600 !important',
    fontFamily: `'Public Sans', sans-serif`,
    padding: '4px 12px',
    borderRadius: '4px',
    '&:hover': {
        backgroundColor: '#4a2db8',
    },
    '&.Mui-disabled': {
        opacity: 0.5,
    }
}));


const Asset = () => {
    const [isAsset, setIsAsset] = useState(false);
    let assetRef = useRef();
    const [isDragging, setIsDragging] = useState(false);
    const [search, setSearch] = useState("");
    const [limit, setLimit] = useState(50)
    const [assetData, setAssetData] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);

    const start = (page - 1) * limit + 1;
    const end = totalPages === page ? totalItems : (page - 1) * limit + limit;

    useEffect(() => {
        fetchData()
    }, [page, search, limit, refresh])

    const fetchData = async () => {
        try {
            setLoading(true);
            const { data, status } = await api.getAllAsset(`?search=${search}&page=${page}&limit=${limit}`)
            if (status === 200) {
                console.log("data----", data)
                setAssetData(data.data)
                setTotalItems(data.totalItems)
                setTotalPages(data.totalPages);
            }
        } catch (err) {

        } finally {
            setLoading(false);
        }
    }

    const handleAsset = () => {
        assetRef.current.click()
    }

    const getFileType = (file) => {
        if (file.type.startsWith("image/")) return "image";
        if (file.type.startsWith("video/")) return "video";
        return "other";
    };

    const uploadFile = async (file) => {
        const fileType = getFileType(file);

        const formData = new FormData();
        formData.append("image", file);
        formData.append("repo", 'assets')
        formData.append("type", fileType);

        try {
            const { data, status } = await api.assetUpload(formData);
            if (status === 200) {
                toast.success("File upload")
                setRefresh(!refresh)
            }
        } catch (err) {
            toast.error("File upload failed")
        }
    };

    const handleFileUpload = async (e) => {
        let files = [...e.target.files]
        if (files?.length > 0) {
            const uploadPromises = files.map((file) => uploadFile(file));
            await Promise.all(uploadPromises);
        }
    }

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => {
        setIsDragging(false);
    };

    const handleDrop = useCallback((e) => {
        e.preventDefault();
        setIsDragging(false);

        const droppedFiles = Array.from(e.dataTransfer.files);
        const filtered = droppedFiles.filter((file) =>
            file.type.startsWith("image/") || file.type.startsWith("video/")
        );

        let files = [...filtered]
        if (files?.length > 0) {
            const uploadPromises = files.map((file) => uploadFile(file));
        }

    }, []);

    const handleAssetDeleted = (id) => {
        setAssetData((prev) => prev.filter((file) => file._id !== id));
        setTotalItems((prev) => prev - 1);
    }

    return (
        <div
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            style={{ minHeight: "90vh" }}
        >
            {
                isDragging && <p style={{ textAlign: "center" }}>
                    Drag your files here
                </p>
            }
            <MasterHeader
                index={"Assets"}
                root={"Dashboard"}
                buttonText={"Add Asset"}
                onClickadd={handleAsset}
                hideBulk={"hide"}
                hideExport={true}
                hideStatus={true}
                hideStatus2={true}
            />

            <input type="file" name="" multiple
                accept="image/*,video/*" onChange={handleFileUpload} ref={assetRef} id="" style={{ display: "none" }} />

            {
                assetData.length > 0 ?
                    <div>
                        <div style={{ display: "flex", gap: 15, flexWrap: "wrap" }}>
                            {
                                assetData.map((file) => (
                                    <RenderFile key={file._id} file={file} onDelete={handleAssetDeleted} />
                                ))
                            }
                        </div>
                        <CatPagination
                            start={start}
                            end={end}
                            totalItems={totalItems}
                            itemsPerPage={limit}
                            setPage={setPage}
                            isDispatch={false}
                            page={page}
                        />
                    </div>
                    : <div>
                        No Asset Uploaded
                    </div>
            }
        </div >
    )
}



const RenderFile = ({ file, onDelete }) => {
    const [name, setName] = useState(file.name || "");
    const [deleting, setDeleting] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const updateFile = async () => {
        try {
            const { data, status } = await api.updateAsset({
                ...file,
                name
            })

            if (status === 200) {
                toast.success("Saved successfully")
            }
        } catch (err) {
            console.log(err);
        }
    }

    // Delete function with proper error handling
    const handleDelete = async (password) => {
        setDeleting(true);
        try {
            const response = await api.deleteAsset(file._id, password);
            if (response.status === 200 || response.status === 204) {
                toast.success("Deleted successfully");
                onDelete(file._id);
            } else {
                toast.error("Failed to delete");
            }
        } catch (err) {
            console.log(err);
            const errorMsg = err.response?.data?.message || err.message || "Failed to delete";
            toast.error(errorMsg);
        } finally {
            setDeleting(false);
            setShowDeleteModal(false);
        }
    }

    return (
        <div style={{ width: "150px", border: "1px solid #512DA8", borderRadius: 5, padding: 10, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
            <div style={{ width: "100%", aspectRatio: 1.4, borderBottom: "1px solid #512DA8", paddingBottom: 10, overflow: "hidden" }}>
                {file.type === "image" ? (
                    <img
                        src={file.url}
                        alt={file.name || "Asset image"}
                        style={{ width: "100%", height: "100%", borderRadius: "8px", objectFit: "contain" }}
                    />
                ) : file.type === "video" ? (
                    <video
                        src={file.url}
                        controls
                        style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: "8px" }}
                    />
                ) : (
                    <p>Unsupported file</p>
                )}
            </div>
            <div onClick={() => handleCopy(file?.url)} style={{ padding: "5px 0px 5px 0" }}>
                <Copy />
            </div>
            <input type="text" value={name} placeholder='Enter name' onChange={(e) => setName(e.target.value)} style={{ width: "100%", marginBottom: "8px", padding: "4px" }} />

            <div style={{ display: "flex", gap: 6, marginTop: 5 }}>
                <DeleteButton
                    variant="contained"
                    onClick={updateFile}
                    disabled={!name || name === file.name || deleting}
                >
                    Save
                </DeleteButton>

                <DeleteButton
                    variant="contained"
                    onClick={() => setShowDeleteModal(true)}
                    disabled={deleting}
                >
                    {deleting ? "Deleting..." : "Delete"}
                </DeleteButton>
            </div>

            <DeleteModal
                isOpen={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onDelete={handleDelete}
                loading={deleting}
                heading="Asset"
            />
        </div>
    )
}

export default Asset